import { motion } from "framer-motion";
import { CASE_STUDIES } from "@/data/content";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function CaseStudiesSection() {
  return (
    <section data-testid="case-studies-section" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="eyebrow">/ 04 · Results in production</div>
            <h2 className="mt-4 font-display text-4xl md:text-5xl font-black tracking-tighter text-white">
              Real platforms. <span className="text-gradient">Real numbers.</span>
            </h2>
          </div>
          <Link
            to="/case-studies"
            className="inline-flex items-center gap-1.5 text-cyan-300 hover:text-cyan-200 font-medium"
            data-testid="case-studies-cta"
          >
            View all case studies <ArrowUpRight size={16} />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {CASE_STUDIES.map((c, i) => (
            <motion.article
              key={c.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: i * 0.1 }}
              className="glass rounded-2xl p-7 flex flex-col"
              data-testid={`case-study-${i}`}
            >
              <span className="font-mono-plex text-[10px] tracking-[0.3em] uppercase text-slate-500">
                {c.industry}
              </span>
              <div className="mt-5 flex items-baseline gap-3">
                <div className="font-display text-5xl font-black text-gradient tracking-tight">
                  {c.metric}
                </div>
                <div className="text-slate-400 text-sm">{c.metricLabel}</div>
              </div>
              <h3 className="mt-6 font-display text-xl font-semibold text-white leading-snug">
                {c.title}
              </h3>
              <p className="mt-3 text-slate-400 text-sm leading-relaxed">{c.copy}</p>
              <div className="mt-6 pt-5 border-t border-white/5 flex items-center justify-between">
                <span className="text-xs text-slate-500 font-mono-plex">CASE STUDY 0{i + 1}</span>
                <Link to="/case-studies" className="text-cyan-300 text-sm hover:text-cyan-200 inline-flex items-center gap-1">
                  Read <ArrowUpRight size={13} />
                </Link>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
